import styled from 'styled-components';

export const TableRowElement = styled.tr`
    height: 20px !important;
`;